"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesHedgeGridProfitTransferProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const lodash_1 = require("lodash");
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
var GridV4FuturesHedgeGridProfitTransferProcessor;
(function (GridV4FuturesHedgeGridProfitTransferProcessor) {
    /**
     * 全仓网格 提取利润检查 api
     * @param id
     * @param data
     */
    GridV4FuturesHedgeGridProfitTransferProcessor.queryCheckInfoApi = (id, data) => {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_hedge_grid/${id}/profit_transfer_check/`,
            data,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    /**
     * 全仓网格 提取利润检查 hooks
     * @param id
     * @param data
     */
    GridV4FuturesHedgeGridProfitTransferProcessor.useCheckInfo = (params) => {
        const { profit, open_price } = params;
        const [checkInfo, setCheckInfo] = (0, react_1.useState)();
        const [loading, setLoading] = (0, react_1.useState)(false);
        const requestRef = (0, react_1.useRef)(params);
        requestRef.current = params;
        const getRequestParams = (0, react_1.useCallback)(() => {
            const id = requestRef.current.exchangeOrder.id;
            const data = {
                profit: requestRef.current.profit || "0",
                long_open_price: requestRef.current.open_price,
                short_open_price: requestRef.current.open_price,
            };
            return { id, data };
        }, []);
        const getCheckInfo = (0, react_1.useCallback)(() => {
            const { id, data } = getRequestParams();
            return GridV4FuturesHedgeGridProfitTransferProcessor.queryCheckInfoApi(id, data)
                .pipe((0, operators_1.catchError)(() => GridV4FuturesHedgeGridProfitTransferProcessor.queryCheckInfoApi(id, Object.assign(Object.assign({}, data), { profit: "0" }))))
                .subscribe({
                next: (data) => {
                    setCheckInfo(data);
                    setLoading(false);
                },
                error: () => {
                    setLoading(false);
                },
                complete: () => {
                    setLoading(false);
                }
            });
        }, [getRequestParams]);
        const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(getCheckInfo, 500));
        const throttleFn = (0, react_1.useRef)((0, lodash_1.throttle)(getCheckInfo, 5000));
        // 用户输入防抖
        (0, react_1.useEffect)(() => {
            var _a;
            setLoading(true);
            const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
            return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        }, [profit]);
        // 当前价格变更节流
        (0, react_1.useEffect)(() => {
            var _a;
            // 只有在当前参数合理时，才去根据价格刷新数据
            if (!checkInfo || !checkInfo.check_result) {
                return;
            }
            if (!Number(profit) // 没有提取利润额
            ) {
                return;
            }
            const sub = (_a = throttleFn.current) === null || _a === void 0 ? void 0 : _a.call(throttleFn);
            return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [open_price]);
        const queryCheckInfo = (0, react_1.useCallback)(() => {
            const { id, data } = getRequestParams();
            return GridV4FuturesHedgeGridProfitTransferProcessor.queryCheckInfoApi(id, data).pipe((0, operators_1.tap)((value) => {
                setCheckInfo(value);
            }));
        }, [getRequestParams]);
        return { checkInfo, queryCheckInfo, loading: loading };
    };
    /**
     * 提取利润提交接口
     */
    const profitTransferSubmitApi = (id, data) => {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_hedge_grid/${id}/transfer/`,
            data: Object.assign({ type: "profit", direction: "out" }, data),
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    // 获取不允许提取利润的原因
    const checkInfoReason = ({ reason, $st }) => {
        switch (reason) {
            default: {
                return $st("grid_futures_cur_profit_check_error");
            }
        }
    };
    /**
     * 全仓网格 中间层
     * @param id
     * @param data
     */
    GridV4FuturesHedgeGridProfitTransferProcessor.useProcessor = (params) => {
        const { exchangeOrder, $st } = params;
        const innerOrder = exchangeOrder.exchangeGridV4FuturesHedgeGridOrder;
        const [profit, setProfit] = (0, react_1.useState)("");
        const profitRef = (0, react_1.useRef)(profit);
        profitRef.current = profit;
        const ticker = (0, trade_quotation_lib_1.useTicker)({ base: exchangeOrder.base, quote: exchangeOrder.quote, interval: 500 });
        const currentPriceRef = (0, react_1.useRef)(ticker === null || ticker === void 0 ? void 0 : ticker.latest);
        currentPriceRef.current = ticker === null || ticker === void 0 ? void 0 : ticker.latest;
        const { checkInfo, queryCheckInfo, loading: checkInfoLoading, } = GridV4FuturesHedgeGridProfitTransferProcessor.useCheckInfo({
            profit,
            exchangeOrder,
            open_price: (ticker === null || ticker === void 0 ? void 0 : ticker.latest) ? new trade_utils_lib_1.SafeDecimal(ticker.latest).toString() : "",
        });
        const longOrderData = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.long;
        const shortOrderData = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.short;
        const profitError = (0, react_1.useMemo)(() => {
            const profitD = new trade_utils_lib_1.SafeDecimal(profit);
            if (profitD.eq(0)) {
                return "";
            }
            if (profitD.gt(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount))) {
                return $st("grid_futures_cur_profit_info_error");
            }
            return "";
        }, [$st, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount, profit]);
        // 最大可提取金额
        const maxProfit = (0, react_1.useMemo)(() => {
            if (!(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount)) {
                return "0";
            }
            return trade_utils_lib_1.NumberCommonUtils.toNormalPrice(checkInfo.max_amount);
        }, [checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.max_amount]);
        // 历史提取金额
        const accumulatedProfit = (0, react_1.useMemo)(() => {
            const profileWithdrawn = new trade_utils_lib_1.SafeDecimal(longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.profitWithdrawn).add((shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.profitWithdrawn) || 0);
            if (profileWithdrawn.gt(0)) {
                return profileWithdrawn.toFixed();
            }
            return "--";
        }, [longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.profitWithdrawn, shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.profitWithdrawn]);
        // 当前预估强平价
        const currentLiquidPrice = (0, react_1.useMemo)(() => {
            return {
                down: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.long_estimate_liquidation_price,
                up: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.short_estimate_liquidation_price,
            };
        }, [checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.long_estimate_liquidation_price, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.short_estimate_liquidation_price]);
        // 提取后预估强平价
        const afterLiquidPrice = (0, react_1.useMemo)(() => {
            return {
                down: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.long_estimate_liquidation_price_after,
                up: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.short_estimate_liquidation_price_after,
            };
        }, [checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.long_estimate_liquidation_price_after, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.short_estimate_liquidation_price_after]);
        // 展示风险信息
        const showRiskInfo = (0, react_1.useMemo)(() => {
            return (((longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.isRunning) && !(longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.isConditionAndNotTriggered)) ||
                ((shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.isRunning) && !(shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.isConditionAndNotTriggered)));
        }, [
            longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.isConditionAndNotTriggered,
            longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.isRunning,
            shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.isConditionAndNotTriggered,
            shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.isRunning,
        ]);
        // 提取后强平价在区间内
        const liquidPriceInRangeTips = (0, react_1.useMemo)(() => {
            if (!showRiskInfo || !profit) {
                return;
            }
            let top;
            let bottom;
            if (longOrderData && shortOrderData && longOrderData.isRunning && shortOrderData.isRunning) {
                top = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(longOrderData.high), new trade_utils_lib_1.SafeDecimal(shortOrderData.high));
                bottom = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(longOrderData.low), new trade_utils_lib_1.SafeDecimal(shortOrderData.low));
            }
            else {
                if (longOrderData && longOrderData.isRunning) {
                    top = new trade_utils_lib_1.SafeDecimal(longOrderData.high);
                    bottom = new trade_utils_lib_1.SafeDecimal(longOrderData.low);
                }
                if (shortOrderData && shortOrderData.isRunning) {
                    top = new trade_utils_lib_1.SafeDecimal(shortOrderData.high);
                    bottom = new trade_utils_lib_1.SafeDecimal(shortOrderData.low);
                }
            }
            if (!top || !bottom) {
                return;
            }
            if (afterLiquidPrice.up &&
                afterLiquidPrice.down &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.up).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.up).greaterThan(bottom) &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.down).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.down).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_in");
            }
            else if (afterLiquidPrice.up &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.up).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.up).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_up");
            }
            else if (afterLiquidPrice.down &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.down).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(afterLiquidPrice.down).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_down");
            }
        }, [$st, afterLiquidPrice.down, afterLiquidPrice.up, longOrderData, profit, shortOrderData, showRiskInfo]);
        // 预估提取后将达到止损设置
        const stopLossTriggerArrived = (0, react_1.useMemo)(() => {
            if (!innerOrder) {
                return false;
            }
            const { loss_stop, loss_stop_type, totalProfit, initQuoteAmount } = innerOrder;
            if (!loss_stop) {
                // 当没有具体的止损值时，则不做检查
                return false;
            }
            const remainProfit = new trade_utils_lib_1.SafeDecimal(totalProfit).minus(new trade_utils_lib_1.SafeDecimal(profit));
            if (loss_stop_type === TradeAPILib_1.GridStopType.profit_amount) {
                return remainProfit.lt(new trade_utils_lib_1.SafeDecimal(loss_stop));
            }
            if (loss_stop_type === TradeAPILib_1.GridStopType.profit_ratio) {
                return remainProfit.div(new trade_utils_lib_1.SafeDecimal(initQuoteAmount)).lt(new trade_utils_lib_1.SafeDecimal(loss_stop));
            }
            return false;
        }, [innerOrder, profit]);
        // 提取后预估强平价相对止损价格不利
        const stopLossInLiquidPriceRange = (0, react_1.useMemo)(() => {
            const data = {
                txt: "",
                showLongStopLoss: false,
                showShortStopLoss: false,
            };
            if (!checkInfo || !profit) {
                return data;
            }
            let longStr = "";
            let shortStr = "";
            if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.long) &&
                innerOrder.long.loss_stop &&
                checkInfo.long_estimate_liquidation_price_after &&
                innerOrder.long.loss_stop_type === TradeAPILib_1.GridStopType.price &&
                new trade_utils_lib_1.SafeDecimal(innerOrder.long.loss_stop).lessThanOrEqualTo(checkInfo.long_estimate_liquidation_price_after)) {
                longStr = $st("hedge_grid_profit_transfer_long_sl_warn");
                data.showLongStopLoss = true;
            }
            if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.short) &&
                innerOrder.short.loss_stop &&
                checkInfo.short_estimate_liquidation_price_after &&
                innerOrder.short.loss_stop_type === TradeAPILib_1.GridStopType.price &&
                new trade_utils_lib_1.SafeDecimal(innerOrder.short.loss_stop).greaterThanOrEqualTo(checkInfo.short_estimate_liquidation_price_after)) {
                shortStr = $st("hedge_grid_profit_transfer_short_sl_warn");
                data.showShortStopLoss = true;
            }
            if (longStr && shortStr) {
                data.txt = $st("hedge_grid_profit_transfer_sl_warn");
                data.showLongStopLoss = true;
                data.showShortStopLoss = true;
            }
            else {
                data.txt = longStr || shortStr;
            }
            return data;
        }, [$st, checkInfo, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.long, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.short, profit]);
        const warningText = (0, react_1.useMemo)(() => {
            if (liquidPriceInRangeTips) {
                return liquidPriceInRangeTips;
            }
            return stopLossInLiquidPriceRange.txt;
        }, [liquidPriceInRangeTips, stopLossInLiquidPriceRange]);
        // 按钮可用
        const enableCommit = new trade_utils_lib_1.SafeDecimal(profit).gt(0) && !profitError && !checkInfoLoading;
        // 提交
        const submit = (0, react_1.useCallback)(() => {
            if (!profitRef.current || !Number(profitRef.current)) {
                return (0, rxjs_1.throwError)($st("trade_error_input_invest"));
            }
            if (!currentPriceRef.current) {
                return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
            }
            return queryCheckInfo().pipe((0, operators_1.mergeMap)((info) => {
                if (info.check_result) {
                    return profitTransferSubmitApi(exchangeOrder.id, {
                        amount: profitRef.current,
                        coin: exchangeOrder.quote,
                        long_open_price: currentPriceRef.current,
                        short_open_price: currentPriceRef.current,
                    });
                }
                const r = checkInfoReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
                if (r) {
                    // 提取利润可能出现的报错
                    return (0, rxjs_1.throwError)(r);
                }
                return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
            }));
        }, [$st, exchangeOrder.id, exchangeOrder.quote, queryCheckInfo]);
        return {
            profit,
            setProfit,
            profitError,
            enableCommit,
            stopLossTriggerArrived,
            stopLossInLiquidPriceRange,
            liquidPriceInRangeTips,
            warningText,
            currentLiquidPrice,
            afterLiquidPrice,
            accumulatedProfit,
            maxProfit,
            ticker,
            showRiskInfo,
            submit,
            checkInfoLoading,
            checkInfo,
        };
    };
})(GridV4FuturesHedgeGridProfitTransferProcessor || (exports.GridV4FuturesHedgeGridProfitTransferProcessor = GridV4FuturesHedgeGridProfitTransferProcessor = {}));
